import { DateDisplayer } from "./DateDisplayer";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TextField } from "@mui/material";
import { Dispatch, SetStateAction } from "react";

type DatesFilterProps = {

    startDate: Date,
    setStartDate: Dispatch<SetStateAction<Date>>,
    endDate: Date,
    setEndDate: Dispatch<SetStateAction<Date>>,
}


export function DatesFilter({startDate, endDate, setStartDate, setEndDate} : DatesFilterProps) {

return(<DateDisplayer >
    <DatePicker
        value={startDate}
        label={'Desde o mês de'}
        openTo="month"
        views={['year', 'month']}
        onChange={(value: Date | null) => setStartDate(value || new Date(Date.now()))}
        renderInput={(params) => <TextField {...params} />}
    />
     <DatePicker
        value={endDate}
        label={'Até o mês de'}
        openTo="month"
        views={['year', 'month']}
        onChange={(value: Date | null) => setEndDate(value || new Date(Date.now()))}
        renderInput={(params) => <TextField {...params} />}
    />
</DateDisplayer>)

}